
import { Injectable, inject } from "@angular/core";
import _ from "lodash";
import { BehaviorSubject } from "rxjs";
import { AnvandareService } from "~app/common/services/anvandare.service";
import { EventService } from "~app/common/services/cqs/event.service";
import { EventHubService } from "~app/common/services/eventhub.service";
import { ArbetsorderWorkEventMessage } from "~app/features/planera/events/ArbetsorderWorkEventMessage";
import { ArbetsorderMonitor, ArbetsorderMonitorService } from "~app/features/planera/services/arbetsorder-monitor.service";

@Injectable({
    providedIn: "root"
})
export class FooterWorkMessageService {
    currentWorkFlat$ = new BehaviorSubject<string>(null);
    monitor: ArbetsorderMonitor;
    userId: string;

    private readonly anvandareService = inject(AnvandareService);
    private readonly arbetsorderMonitorService = inject(ArbetsorderMonitorService);
    private readonly eventHubService = inject(EventHubService);
    private readonly eventService = inject(EventService);

    connect(): void {
        this.monitor = this.arbetsorderMonitorService.connect(true);
        this.initArbetsorderSubscription();
        this.anvandareService.getCurrentUserId().subscribe(userId => {
            this.userId = userId.toString();
            this.eventHubService.registerListener(`anvandare/${userId}`);
            this.eventService.subscribeAllArbetsorderSaga().subscribe();
        });
    }

    disconnect(): void {
        this.monitor.disconnect();
    }

    private initArbetsorderSubscription() {
        this.monitor.workInProgress$.subscribe(x => {
            const messages = _.chain(x)
                .filter(message => message.status === ArbetsorderWorkEventMessage.pending)
                .map(message => message.workDescription)
                .groupBy()
                .map((values, key) => values.length > 1 ? `${key} (${values.length})...` : `${key}...`)
                .value()
                .join("   ");
            this.currentWorkFlat$.next(messages);
        });
    }
}
